import { render } from "./Dash.vue?vue&type=template&id=f8ad2884"
import script from "./Dash.vue?vue&type=script&lang=js"
export * from "./Dash.vue?vue&type=script&lang=js"
script.render = render

export default script